module.exports = __webpack_public_path__ + "media/images/admin/icons/user-plus-7df9a289df2eaf4229e6091b340a9799.svg";